const DiningRoomSkeleton = () => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="rounded-xl border border-stroke bg-white p-5 shadow-sm dark:border-strokedark dark:bg-boxdark"
        >
          {/* Header */}
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 animate-pulse rounded-xl bg-gray-2 dark:bg-meta-4" />

              <div>
                <div className="h-4 w-36 animate-pulse rounded bg-gray-2 dark:bg-meta-4" />
                <div className="mt-2 h-3 w-20 animate-pulse rounded bg-gray-2 dark:bg-meta-4" />
              </div>
            </div>

            <div className="h-6 w-18 animate-pulse rounded-full bg-gray-2 dark:bg-meta-4" />
          </div>

          {/* Description */}
          <div className="mt-6 space-y-2">
            <div className="h-3 w-full animate-pulse rounded bg-gray-2 dark:bg-meta-4" />
            <div className="h-3 w-5/6 animate-pulse rounded bg-gray-2 dark:bg-meta-4" />
          </div>

          {/* Footer */}
          <div className="mt-6 flex gap-2 border-t border-stroke pt-4 dark:border-strokedark">
            <div className="h-10 flex-1 animate-pulse rounded bg-gray-2 dark:bg-meta-4" />
            <div className="h-10 w-10 animate-pulse rounded bg-gray-2 dark:bg-meta-4" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DiningRoomSkeleton;
